import {checarGrupo, checarFuncao} from './helpers'

export const TIPOS_RELATORIO = {
  relacionados: 1,
  vendasPorArrematantes: 2,
  leiloeiro: 3,
  prestacaoDeContas: 4
}

export const GRUPOS_RELATORIO = {
  habilitarFiltroData: [],
  leilao: [
    TIPOS_RELATORIO.relacionados,
    TIPOS_RELATORIO.vendasPorArrematantes,
    TIPOS_RELATORIO.leiloeiro,
    TIPOS_RELATORIO.prestacaoDeContas
  ],
  habilitarFiltroPatio: [],
  checarGrupo
}

export const MENU = {
  'Leilão': [
    {
      label: 'Relacionados',
      value: TIPOS_RELATORIO.relacionados,
      selected: true,
      disabled: false
    },
    {
      label: 'Vendas por arrematantes',
      value: TIPOS_RELATORIO.vendasPorArrematantes,
      selected: false,
      disabled: false
    },
    {
      label: 'Leiloeiro (Emissão de notas)',
      value: TIPOS_RELATORIO.leiloeiro,
      selected: false,
      disabled: false
    },
    {
      label: 'Leiloeiro - Prestação de contas',
      value: TIPOS_RELATORIO.prestacaoDeContas,
      selected: false,
      disabled: false
    }
  ]
}

export const FUNCTIONS = {
  [TIPOS_RELATORIO.relacionados]: 'gerarRelatorioRelacionados',
  [TIPOS_RELATORIO.vendasPorArrematantes]: 'gerarRelatorioVendasPorArrematantes',
  [TIPOS_RELATORIO.leiloeiro]: 'gerarRelatorioLeiloeiro',
  [TIPOS_RELATORIO.prestacaoDeContas]: 'gerarRelatorioPrestacaoDeContas',
  checarFuncao
}

export default {TIPOS_RELATORIO, GRUPOS_RELATORIO, MENU, FUNCTIONS}




// WEBPACK FOOTER //
// ./src/app/website/relatorios-gerenciais/config-tipos-relatorio/leilao.js